// Página de configurações
import { Card } from '../../components/common/Card';
import { Button } from '../../components/common/Button';
import { Input } from '../../components/common/Input';
import { Select } from '../../components/common/Select';
import { Breadcrumbs } from '../../components/layout/Breadcrumbs';
import { Save } from 'lucide-react';

export function Configuracoes() {
  return (
    <div className="space-y-6">
      <Breadcrumbs items={[{ label: 'Configurações' }]} />
      
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Configurações</h1>
      </div>
      
      {/* Configurações Gerais */}
      <Card>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
          Configurações Gerais
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input label="Nome do Sistema" defaultValue="NF Sistema" />
          <Select
            label="Idioma"
            options={[
              { value: 'pt-BR', label: 'Português (Brasil)' },
              { value: 'en', label: 'English' },
            ]}
          />
          <Select
            label="Timezone"
            options={[
              { value: 'America/Sao_Paulo', label: 'America/São Paulo' },
            ]}
          />
        </div>
        <div className="flex justify-end mt-4">
          <Button variant="primary">
            <Save className="w-4 h-4 mr-2" />
            Salvar Configurações
          </Button>
        </div>
      </Card>
      
      {/* Configurações de Emissão */}
      <Card>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
          Configurações de Emissão
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input label="Série Padrão" defaultValue="001" />
          <Input label="Número Inicial" type="number" defaultValue="1" />
          <Select
            label="Ambiente"
            options={[
              { value: 'homologacao', label: 'Homologação' },
              { value: 'producao', label: 'Produção' },
            ]}
          />
        </div>
        <div className="flex justify-end mt-4">
          <Button variant="primary">
            <Save className="w-4 h-4 mr-2" />
            Salvar Configurações
          </Button>
        </div>
      </Card>
    </div>
  );
}
